<template>
  <div>
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'MembersBase',
  }
</script>

<style scoped>

</style>
